import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpOperatorRoleFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

/**
 * A small dynamic enum representing places that the editor knows how to display an ExpOperator, such as Join, Line, Expression
 * @export
 * @interface ExpOperatorRole
 */

export class ExpOperatorRoleFactory {}
_ExpOperatorRoleFactory = ExpOperatorRoleFactory;
_defineProperty(ExpOperatorRoleFactory, "FromJSON", function (json) {
  return _ExpOperatorRoleFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpOperatorRoleFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'id': json['id'],
    'placeholderOperatorID': json['placeholderOperatorID'],
    'description': json['description'],
    'excludeFromSourceInput': json['excludeFromSourceInput']
  };
});
_defineProperty(ExpOperatorRoleFactory, "ToJSON", function (value) {
  return _ExpOperatorRoleFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpOperatorRoleFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'id': value.id,
    'placeholderOperatorID': value.placeholderOperatorID,
    'description': value.description,
    'excludeFromSourceInput': value.excludeFromSourceInput
  };
});
//# sourceMappingURL=ExpOperatorRole.js.map
